<template>
  <QInput
    :class="[
      'sai-input',
      { 'sai-input--large': large, 'sai-input--extra-large': extraLarge }
    ]"
    ref="QInput"
    v-on="boundListeners"
    @input="updateInput"
    v-bind="$attrs"
    :dense="dense"
    :clearable="clearable"
    :hide-bottom-space="hideBottomSpace"
    :type="type"
    borderless
    no-error-icon
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </QInput>
</template>

<script>
import { QInput } from 'quasar';

export default {
  name: 'SAIInput',
  props: {
    dense: {
      default: true
    },
    clearable: {
      default: true
    },
    hideBottomSpace: {
      default: true
    },
    large: Boolean,
    extraLarge: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    boundListeners() {
      // Exclude the input listener as it has a custom handler through updateInput
      const { input, ...rest } = this.$listeners;
      return rest;
    }
  },
  methods: {
    updateInput(value) {
      if (!value && value !== 0) {
        this.$refs.QInput.innerValue = undefined;
        return this.$emit('input', undefined);
      }
      if (this.type === 'number' && value) {
        return this.$emit('input', parseFloat(value));
      }
      return this.$emit('input', value);
    },
    resetValidation() {
      return this.$refs.QInput.resetValidation();
    },
    validate(e) {
      return this.$refs.QInput.validate(e);
    },
    focus(e) {
      return this.$refs.QInput.focus(e);
    },
    blur(e) {
      return this.$refs.QInput.blur(e);
    },
    select(e) {
      return this.$refs.QInput.select(e);
    }
  },
  components: { QInput }
};
</script>
